/* eslint-disable */
import React from "react";
import withIconComponent from "../withIconComponent";

var DownloadPdf = function DownloadPdf() {
  return /*#__PURE__*/React.createElement("g", {
    id: "Product-details--one-format---Desktop-and-Mobile",
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    "fill-rule": "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PDP---One-price-One-format---Mobile---Default-",
    transform: "translate(-296.000000, -720.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Table-of-contents",
    transform: "translate(18.000000, 711.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(276.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    transform: "translate(3.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9,38.6 C23.9,39.6 23.6,40.4 23,40.9 C22.4,41.4 21.5,41.7 20.3,41.7 L19.5,41.7 L19.5,45 L17.5,45 L17.5,35.7 L20.5,35.7 C21.6,35.7 22.5,35.9 23.1,36.4 C23.6,36.9 23.9,37.7 23.9,38.6 Z M19.4,40.1 L20,40.1 C20.6,40.1 21.1,40 21.4,39.7 C21.7,39.4 21.9,39.1 21.9,38.7 C21.9,38.2 21.8,37.9 21.5,37.7 C21.2,37.5 20.9,37.4 20.3,37.4 L19.4,37.4 L19.4,40.1 L19.4,40.1 Z",
    fill: "#FF6400",
    "fill-rule": "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6,40.3 C33.6,41.8 33.2,43 32.3,43.8 C31.4,44.6 30.2,45 28.5,45 L25.9,45 L25.9,35.7 L28.8,35.7 C30.3,35.7 31.5,36.1 32.3,36.9 C33.2,37.7 33.6,38.8 33.6,40.3 Z M31.5,40.3 C31.5,38.3 30.6,37.3 28.9,37.3 L27.9,37.3 L27.9,43.3 L28.7,43.3 C30.6,43.4 31.5,42.4 31.5,40.3 Z",
    fill: "#FF6400",
    "fill-rule": "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FF6400",
    "fill-rule": "nonzero",
    points: "37.7 45 35.8 45 35.8 35.7 41.1 35.7 41.1 37.3 37.7 37.3 37.7 39.7 40.8 39.7 40.8 41.3 37.7 41.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    stroke: "#404040",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    points: "37 0 37 16 53 16"
  }), /*#__PURE__*/React.createElement("polyline", {
    stroke: "#404040",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    points: "53 30 53 16 37 0 5 0 5 30"
  }), /*#__PURE__*/React.createElement("polyline", {
    stroke: "#404040",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    points: "5 51 5 60 53 60 53 51"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "58",
    y1: "30",
    x2: "0",
    y2: "30",
    stroke: "#404040",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    stroke: "#404040",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    points: "5 25 0 30 0 51 58 51 58 30 53 25"
  }))))));
};

export default withIconComponent("UiDownloadPdf", true)(DownloadPdf);